module.exports = __webpack_public_path__ + "static/img/Review-z@2x.ad375d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/Review-z@2x.png
// module id = i8+0
// module chunks = 96